import styled, { css } from "styled-components";

interface CssProps extends React.CSSProperties {}

const styles = css<CssProps>`
  font-family: ${({ theme }) => theme.fontFamily};

  ${(props) => props.fontSize && `font-size: ${props.fontSize};`}
  ${(props) => props.fontWeight && `font-weight: ${props.fontWeight};`}
  ${(props) => props.letterSpacing && `letter-spacing: ${props.letterSpacing};`}
  ${(props) => props.color && `color: ${props.color};`}
  ${(props) => props.margin && `margin: ${props.margin};`}
  ${(props) => props.marginBottom && `margin-bottom: ${props.marginBottom};`}
  ${(props) => props.maxWidth && `max-width: ${props.maxWidth};`}
`;

const Header = styled.h1<CssProps>`
  ${styles}
`;
const Header2 = styled.h2<CssProps>`
  ${styles}
`;
const Header3 = styled.h3<CssProps>`
  ${styles}
`;
const Header4 = styled.h4<CssProps>`
  ${styles}
`;
const Header5 = styled.h5<CssProps>`
  ${styles}
`;

const Paragraph = styled.p<CssProps>`
  ${styles}
`;
const Span = styled.span<CssProps>`
  ${styles}
`;

const Typography = {
  Header,
  Header2,
  Header3,
  Header4,
  Header5,
  Paragraph,
  Span,
};

export default Typography;
